import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import Routes from "../../navigation/route/Route";
import CreateQuoteForm from "./form/create/CreateQuoteForm";
import {Boxed} from "../../hiberUiKit/src/molecules/Boxed/Boxed";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";

interface RouteProps {
	/**
	 * Lead reference number.
	 */
	leadReferenceNumber: string
}

type Props = RouteComponentProps<RouteProps> ;

/**
 * Create quote view.
 */
class CreateQuote extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create Installation Quote"}/>
				<PageContentView>
					<CreateQuoteForm onSuccess={this.onSuccess}
									 leadReferenceNumber={this.props.match.params.leadReferenceNumber}
									 onNoData={() => this.props.history.push(Routes.LeadsList)}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On success quote creation.
	 */
	private onSuccess() {
		this.props.history.push(Routes.EditLead(this.props.match.params.leadReferenceNumber));
	}
}


export default withRouter(CreateQuote);
